import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 3.5L5 7l3.5-3.5", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "bevel" }));
export default SvgChevronDown;
